import * as React from "react";
import { Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../actions";
import strings from "./Localization";

class EnsureSuperAdmin extends React.Component {
    render() {
        const { currentuser, location, children } = this.props;

        if (!currentuser) {
            return <div style={{ padding: 24 }}>{strings.Loading}</div>;
        }

        // Connected => check isSystemAdministrator
        const isSuperAdmin
      = currentuser
      && currentuser.user
      && currentuser.user.isSystemAdministrator === true;

        if (isSuperAdmin) {
            return children;
        }

        // Connected but not have accessrights
        return (
            <Redirect
                to={{
                    pathname: "/notauthorized", // recommandé (ou "/dashboard")
                    state: { from: location.pathname + location.search }
                }}
            />
        );
    }
}

const mapStateToProps = (state) => state;
const mapDispatchToProps = (dispatch) => bindActionCreators(ActionsCreators, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnsureSuperAdmin));
